export default __webpack_public_path__ + "static/media/pantry1-afterA-1920w.e0c3f1e4.png";